import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { BiCaretDown, BiCaretUp } from 'react-icons/bi';
import { useLocation, useNavigate } from 'react-router-dom';

import { LanguageMapper, MultiLanguageUrl } from '../../constants/multiLanguage.constant';

const LanguageChangeDropdownShort = ({ theme, size = 'lg' }: { theme?: string; size?: 'lg' | 'sm' }) => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const lngFlagMapper = {
    'en-US': 'https://cdn.1cdn.app/application/UMD/24041507435389_US.png',
    'fr-FR': 'https://cdn.1cdn.app/application/UMD/24041507435387_France.png',
  } as { [key: string]: string };

  const [toggle, setToggle] = useState(true);

  const CustomToggle = React.forwardRef(({ children, onClick }: { children: any; onClick: any }, ref) => (
    <span
      onClick={e => {
        e.preventDefault();
        onClick(e);
        setToggle(prev => !prev);
      }}
      onKeyDown={e => {
        e.preventDefault();
        onClick(e);
        setToggle(prev => !prev);
      }}
      id="btn-language-short-custom-toggle"
      role="button"
      tabIndex={-1}
    >
      {children}
    </span>
  ));

  CustomToggle.displayName = 'CustomToggle';

  const selectHandler = (l: string) => {
    const url = new URL(window.location.href);
    const params = url.search || '';
    const from = pathname.replace(MultiLanguageUrl[i18n.language], MultiLanguageUrl[l]);

    i18n.changeLanguage(l);
    navigate(from + params, {
      replace: true,
    });
  };

  return (
    <div className="tw-h-10 tw-pl-1.5 tw-pr-2 tw-py-1.5 tw-bg-gray-200 tw-rounded-full tw-justify-start tw-items-center tw-gap-1 tw-inline-flex">
      <div>
        <Dropdown>
          <Dropdown.Toggle as={CustomToggle}>
            <div className="tw-flex tw-justify-center tw-items-center tw-gap-1">
              <img className={`tw-w-6 tw-h-6 tw-rounded-full`} src={lngFlagMapper[MultiLanguageUrl[i18n.language || 'en']]} alt="flag" />

              {toggle && <BiCaretUp size={16} className={`${theme == 'light' ? 'tw-text-black' : 'tw-text-gray-600'}`} />}
              {!toggle && <BiCaretDown size={16} className={`${theme == 'light' ? 'tw-text-black' : 'tw-text-gray-600'}`} />}
            </div>
          </Dropdown.Toggle>

          <Dropdown.Menu className={`tw-bottom-7 ${size === 'sm' ? 'tw-left-3' : 'tw-right-3'}`}>
            {Object.keys(i18n.services.resourceStore.data).map(l => (
              <Dropdown.Item key={l} onClick={() => selectHandler(l)}>
                {LanguageMapper[l]}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>
      <div className="w-4 h-4 relative" />
    </div>
  );
};

export default LanguageChangeDropdownShort;
